import { useNavigate } from 'react-router-dom';
import { Box } from 'theme-ui';

import { LoadingBox } from '@/components/Collection/LoadingBox';
import { formatMarkets } from '@/components/Collection/utils';
import DataTable, { DataTableColumn } from '@/components/DataTable';
import {
  GetCollectionsPageQuery,
  useGetCollectionsPageQuery,
} from '@/graphql/types/generated';

type CollectionsPageEntry = GetCollectionsPageQuery['collectionsPage'][0];

export default function CollectionPagesTab({
  totalWarehouses,
}: {
  totalWarehouses: number;
}) {
  const navigate = useNavigate();
  const [{ data, fetching }] = useGetCollectionsPageQuery({
    requestPolicy: 'cache-and-network',
  });

  if (fetching) return <LoadingBox />;

  const collectionPagesColumns: DataTableColumn<CollectionsPageEntry>[] = [
    {
      header: 'Collection Name',
      id: 'name',
      accessorFn: (row) => row.collection.name ?? '(unnamed)',
    },
    {
      header: 'Markets',
      id: 'markets',
      accessorFn: (row) => formatMarkets(row.warehouses, totalWarehouses),
    },
  ];

  return (
    <Box sx={{ pt: 3 }}>
      <DataTable<CollectionsPageEntry>
        columns={collectionPagesColumns}
        data={data?.collectionsPage ?? []}
        containerStyles={{ marginTop: 0 }}
        onRowClick={(row) => navigate(`/collections/${row.collection.id}`)}
      />
    </Box>
  );
}
